import React, { useEffect, useRef } from "react";
import { Html } from "@react-three/drei";

import { accessors, formatTimeDayMonthYear } from "../../utils";

export const Tooltip = ({ data = null }) => {
  const positionRef = useRef([0, 0, 0]);
  useEffect(() => {
    positionRef.current = !!data
      ? [data.x, data.y, data.z]
      : positionRef.current;
  }, [data]);
  const showTooltip = !!data;
  const position = showTooltip ? [data.x, data.y, data.z] : positionRef.current;
  const text = showTooltip ? data.description : "";

  return (
    showTooltip && (
      <group>
        <Html
          // style={{ ...style }}
          position={position}
          className="flex flex-column block-font width-30ch bg-primary p1"
        >
          <div className="mb1">
            {formatTimeDayMonthYear(accessors.date.start(data))}
          </div>
          <div>
            {text.slice(0, 100)}
            {!!data && `...`}
          </div>
        </Html>
      </group>
    )
  );
};
